<script lang="ts">
    import NauiCheckbox from "../../lib/naui/atoms/NauiCheckbox.svelte";


    export const refs = [];
    export let data;
    export let subruta: string; 
    

</script>

<tr>
    <td margin-top="4%" >
        <div class="checkbox_container">
            <NauiCheckbox bind:value={data.checked} />
        </div>
    </td>
    <td>
        {data.Direccion_descripcion} 
    </td>
    {#if subruta === "paqueteCompleto"}
        <td> {data.PO} </td>
    {/if}
    <td>
        {data.referencia_sel} 
    </td>
    {#if subruta === "maquila"}
        <td>
            {data.TipoAuditoria}
        </td>
        <td style="text-align:start; ml-2%">
            {data.Orden}
        </td>
        <td>
            <NauiCheckbox bind:value={data.Liquidar} disabled={true} />
        </td>
        <td>
            <NauiCheckbox bind:value={data.Critica} disabled={true} />
        </td>
        <td>
            <NauiCheckbox bind:value={data.Auditada} disabled={true} />
        </td>
    {/if}
    <td>
        {data.TipoEmpaque}
    </td>
    <td width="150px">
        {data.Q != "" ? data.Q : "N/A"}
    </td>
    <td width="150px">
        {data.Cantidad}
    </td>
    <td>
        {new Date(new Date(data.Fecha).setDate(new Date(data.Fecha).getDate() + 1)).toLocaleDateString('es-CO')}
    </td>
    <td>
        {data.Hora}
    </td>
    <td>
        <NauiCheckbox bind:value={data.Medida} disabled={true} />
    </td>
    <td>
        <NauiCheckbox bind:value={data.Empaque} disabled={true} />
    </td>
    <td>
        <NauiCheckbox bind:value={data.Confeccion} disabled={true} />
    </td>
</tr>

<style>
    td {
        text-align:start;
        padding-left: 20px;
    }
    .checkbox_container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

</style>
